<template>
  <div class="markup">
    <div class="markup__subtitle markup__subtitle_head">ТТ Формат Pre-roll (размещение в видеоплеере)</div>

    <div class="markup__h markup__h_2">
      <strong>Возможные варианты размещения:</strong>
    </div>
    <ul class="markup__ul markup__ul_nested">
      <li>
        <div class="markup__h markup__h_3">
          <strong>Видеоролик:</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Формат: MP4</li>
          <li>Видеокодек: H.264</li>
          <li>Аудиокодек: MP3 или AAC</li>
          <li>Разрешение: рекомендуется не ниже Full HD 1080p</li>
          <li>Частота кадров: 30 в секунду</li>
          <li>Соотношение сторон: 16:9</li>
        </ul>
      </li>
      <li>
        <div class="markup__h markup__h_3">
          <strong>
            <a href="https://www.iab.com/wp-content/uploads/2015/06/VPAID_2_0_Final_04-10-2012.pdf" class="link">VAST,</a>&nbsp;
            <a href="https://www.iab.com/wp-content/uploads/2015/06/VASTv3_0.pdf" class="link"> VPAID</a>
          </strong>
        </div>
      </li>
    </ul>

    <marked-zone-atention></marked-zone-atention>
  </div>
</template>

<script>
import markedZoneAtention from '@/components/documentation/markedZoneAtention.vue';

export default {
  name: 'preroll',
  components: {
    markedZoneAtention,
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang='stylus'>
@import '../../../styles/main.styl'
@import '../../../styles/documentation_article_markup.styl'

</style>
